<h1 mat-dialog-title>Formatting</h1>
<div mat-dialog-content>
    Would you like the data to be formatted?
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onNoFormatClick()">No</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onFormatClick()">Yes</button>
</div>
